module.exports = __webpack_public_path__ + "static/media/intellij.b94a4cdd.png";